<template>
    <keep-alive include="customize-website">
        <router-view @selectedTemplate="selectedTemplate" @previewTemplate="previewTemplate"></router-view>
    </keep-alive>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        methods: {
            selectedTemplate(id) {
                const url = `/guest/select-template`;

                axios.post(url, {template_id: id, language: i18n.locale })
                    .then(function (response) {
                        this.$router.push({
                            name: 'customize-website',
                            params: {
                                template: id,
                                lang: i18n.locale == 'en' ? null : i18n.locale,
                                back_route: "getting-started"
                            }
                        })
                    }.bind(this))
                    .catch(error => {
                        this.$toastr.error(DEFAULT_ERROR_MESSAGE);
                    })
            },
            previewTemplate(id) {
                this.$router.push({
                    name: 'preview-template',
                    params: {
                        template: id,
                        lang: i18n.locale == 'en' ? null : i18n.locale,
                        back_route: "getting-started"
                    }
                })
            }
        }
    }
</script>
